import { useConfirmArchiveModal } from '@/composables';
import { computed, ref } from '@vue/composition-api';
import { useAuthUser } from '@/composables/use-auth-user';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { UserRole } from '@/api/requests/users';
import EditSvg from '@/assets/icons/edit.svg';
import ArchiveSvg from '@/assets/icons/archive.svg';
const { useActions: useCommonActions } = createNamespacedHelpers('common');
export const usePlaceActions = (ctx) => {
    const listUpdatesCounter = ref(0);
    const deletionInProgress = ref(false);
    const { isAdmin, hasRoleAccessOrHigher } = useAuthUser();
    const structureAdminOrHigherAccess = computed(() => hasRoleAccessOrHigher.value(UserRole.STRUCTURE_ADMIN));
    const onEditBtnClick = (id) => {
        ctx.root.$router.push({ name: 'EditPlace', params: { placeId: id } });
    };
    const { archive: archivePlace } = useCommonActions(['archive']);
    const onArchiveBtnClick = async (id) => {
        deletionInProgress.value = true;
        try {
            await archivePlace({ type: 'places', id });
            listUpdatesCounter.value++;
            ctx.root.$toast.success(ctx.root.$t('brand-places-list-view.archived-successfully'));
        }
        finally {
            deletionInProgress.value = false;
        }
    };
    const { getConfirmArchiveModalObject } = useConfirmArchiveModal(ctx);
    const getPlaceActions = (place) => {
        if (!structureAdminOrHigherAccess.value)
            return [];
        const placeActions = [
            {
                name: 'edit',
                handler: () => onEditBtnClick(place.id),
                icon: EditSvg,
            },
        ];
        if (isAdmin.value)
            placeActions.push({
                name: 'archive',
                handler: () => onArchiveBtnClick(place.id),
                modal: getConfirmArchiveModalObject('place', place.name),
                icon: ArchiveSvg,
            });
        return placeActions;
    };
    return {
        getPlaceActions,
        listUpdatesCounter,
    };
};
